import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import AppRouter from './Router';
import reducers from './reducers';

const historyConfig = { basename: '/FundSpec/GoodDay/' };
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV !== 'production') {
  historyConfig.basename = '';
}

const history = createBrowserHistory(historyConfig);

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

const appStore = createStoreWithMiddleware(reducers);

const chkLogin = () => {
  appDom();
  
}

const appDom = () => {
  ReactDOM.render(
    <Provider store={appStore}>
      <Router history={history}>
        <AppRouter />
      </Router>
    </Provider>, document.getElementById('root'));
}

chkLogin();